var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 8 } }, [
        _c("span", { staticClass: "grey fs-3" }, [
          _vm._v(_vm._s(_vm.amountWording))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("strong", { staticClass: "fs-4" }, [
          _vm._v(
            _vm._s(
              _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                _vm.sharedState.transactionAmount,
                this.transactionNumFormat
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 8 } }, [
        _c("span", { staticClass: "grey fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Montant rapproché :")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("strong", { staticClass: "fs-4" }, [
          _vm._v(
            _vm._s(
              _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                _vm.reconciledAmount,
                this.transactionNumFormat
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("el-col", { attrs: { span: 8 } }, [
        _c("span", { staticClass: "grey fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Reste à rapprocher :")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("strong", { staticClass: "fs-4" }, [
          _vm._v(
            _vm._s(
              _vm.$filters.numberFormatCurrencyCustomNumberFormat(
                _vm.remainingReconciledAmount,
                this.transactionNumFormat
              )
            )
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }